import type { ReactNode } from 'react';

import { match, P } from 'ts-pattern';

import { DialogCloseButton } from '@nesso/ui/primitives/dialog';
import {
    Popover,
    PopoverClose,
    PopoverContent,
    PopoverTrigger,
} from '@nesso/ui/primitives/popover';

import { formatDateTime } from '@/shared/lib/time-utils';

type Props = {
    open: boolean;
    onOpen: (open: boolean) => void;
    deletedAt?: string | null;
    isAutoDeleted?: boolean | null;
    trigger: ReactNode;
};

export function TranscriptUnavailablePopover({
    open,
    onOpen,
    deletedAt,
    isAutoDeleted,
    trigger,
}: Props) {
    const message = match({ isAutoDeleted, deletedAt })
        .with(
            { isAutoDeleted: true, deletedAt: P.nonNullable },
            ({ deletedAt }) => `Transcript auto-deleted ${formatDateTime(deletedAt)}`,
        )
        .with(
            { isAutoDeleted: false, deletedAt: P.nonNullable },
            ({ deletedAt }) => `Transcript deleted ${formatDateTime(deletedAt)}`,
        )
        .otherwise(() => 'No transcript available');

    return (
        <Popover open={open} onOpenChange={onOpen}>
            <PopoverTrigger asChild>{trigger}</PopoverTrigger>
            <PopoverContent
                side="top"
                align="start"
                sideOffset={8}
                className="relative flex items-center justify-between w-auto p-4"
            >
                <p className="text-sm text-foreground pr-8">{message}</p>
                <PopoverClose asChild>
                    <DialogCloseButton className="absolute top-4 right-4 hover:bg-accent hover:text-muted-foreground" />
                </PopoverClose>
            </PopoverContent>
        </Popover>
    );
}
